<mat-chip-grid #chipGrid aria-label="Diagnosis selection">
  @for (value of selectedValues; track value) {
    <mat-chip-row
      [removable]="removable"
      (removed)="remove(value)">
      {{displayChip(value)}}
      @if (removable) {
        <mat-icon matChipRemove>cancel</mat-icon>
      }
    </mat-chip-row>
  }
  <input
    class="input"
    placeholder="{{'autocomplete.placeholder' | translate}}"
    #inputElement
    [formControl]="autocompleteInputCtrl"
    [matAutocomplete]="auto"
    [matChipInputFor]="chipGrid"
    [matChipInputSeparatorKeyCodes]="separatorKeysCodes">
  </mat-chip-grid>
  <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
    @for (group of filteredValues | async; track group) {
      <mat-optgroup [label]="group.displayName">
        @for (diagnosis of group.values; track diagnosis) {
          <mat-option [value]="{id:diagnosis.id, category: diagnosis.category}">
            {{diagnosis.displayName}}
          </mat-option>
        }
      </mat-optgroup>
    }
  </mat-autocomplete>
